document.addEventListener("DOMContentLoaded", () => {
    function t() {
        document.querySelectorAll(".sizes-toggle__checkbox > input").forEach(e => {
            e.addEventListener("change", function () {
                var e = this.value;

                var sizeContainer = document.querySelector(".sizes-values");
                if (!sizeContainer) return;

                sizeContainer.classList.remove("sizes-values--eu", "sizes-values--uk", "sizes-values--us");
                sizeContainer.classList.add("sizes-values--" + e);
                localStorage.setItem("sizeSystem", e);

                var checkedInput = sizeContainer.querySelector("input:checked");
                var span = checkedInput?.nextElementSibling?.querySelector("span[data-unit=" + e.toUpperCase() + "]");
                var s = span ? span.innerHTML : "";

                if (e !== "eu") {
                    document.querySelector(".sizes-picker__properties").value = s;
                    document.querySelector(".sizes-picker__properties").setAttribute("name", "properties[" + e.toUpperCase() + " Size]");
                } else {
                    document.querySelector(".sizes-picker__properties").value = "";
                }

                i(); // Update mobile label
            });
        });

        var mobToggle = document.querySelector(".sizes-values-mob-select");
        if (mobToggle) {
            mobToggle.addEventListener("click", function () {
                this.classList.toggle("active");
            });
        }
    }

    function i() {
        if (window.innerWidth >= 700) return;

        var e = localStorage.getItem("sizeSystem");
        var labelSpan = document.querySelector(".sizes-values-mob-select > span");
        var checkedInput = document.querySelector(".sizes-values > input:checked");

        if (!e || !labelSpan || !checkedInput) return;

        var s = labelSpan.getAttribute("data-label") || "";
        var span = checkedInput?.nextElementSibling?.querySelector("span[data-unit=" + e.toUpperCase() + "]");
        var t = span ? span.innerHTML : "";

        labelSpan.innerHTML = s + " " + e.toUpperCase() + " : " + t;
    }

    if (!localStorage.getItem("sizeSystem")) {
        localStorage.setItem("sizeSystem", "eu");
    }

    t();

    document.addEventListener("variant:change", function () {
        t();
        var s = localStorage.getItem("sizeSystem");

        var input = document.querySelector('.sizes-toggle__checkbox > input[value="' + s + '"]');
        if (input) input.click();

        var sizeContainer = document.querySelector(".sizes-values");
        if (sizeContainer) {
            sizeContainer.classList.remove("sizes-values--eu", "sizes-values--uk", "sizes-values--us");
            sizeContainer.classList.add("sizes-values--" + s);
        }

        if (typeof window.iwishInit === "function") window.iwishInit();
        if (typeof window.iWishAddReload === "function") window.iWishAddReload();

        i();
    });
});